import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiInstance } from "./axiosApi";
import authHeader from "./authHeader";

export const getTrustedInstitutes = createAsyncThunk(
  "admin/allTrustedInstitutes",
  async ({ page, limit, searchData }, { rejectWithValue }) => {
    try {
      let url = `/trusted-institute/all`;
      if (page && limit) {
        url += `?page=${page}&limit=${limit}`;
        if (searchData) url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, { headers: authHeader() });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const addTrustedInstitute = createAsyncThunk(
  "admin/addTrustedInstitute",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/trusted-institute/add`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const editTrustedInstitute = createAsyncThunk(
  "admin/editTrustedInstitute",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/trusted-institute/edit`, payload, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const getSingleTrustedInstitute = createAsyncThunk(
  "admin/singleTrustedInstitute",
  async (id, { rejectWithValue }) => {
    try {
      const response = await apiInstance.get(`/trusted-institute/${id}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

export const deleteTrustedInstitute = createAsyncThunk(
  "admin/deleteTrustedInstitute",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(`/trusted-institute/delete/${selectedId}`, {
        headers: authHeader(),
      });
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  }
);

const initialState = {
  trustedByData: [],
  singleTrustedByData: [],
};

const trustedInstituteSlice = createSlice({
  name: "trustedInstituteSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTrustedInstitutes.fulfilled, (state, action) => {
      state.trustedByData = action.payload.data;
    });
    builder.addCase(getSingleTrustedInstitute.fulfilled, (state, action) => {
      state.singleTrustedByData = action.payload.data;
    });
  },
});

export default trustedInstituteSlice.reducer;


